import { Dropdown, Menu } from "antd";
import cn from "classnames";
import { FC, PropsWithChildren, ReactNode, useEffect, useState } from "react";

import styles from "./DropdownPopover.module.scss";

type DropdownSelectProps = {
  content: ReactNode;
  transparent?: boolean;
  shadow?: boolean;
  placement?:
    | "topLeft"
    | "topCenter"
    | "topRight"
    | "bottomLeft"
    | "bottomCenter"
    | "bottomRight";
  disabled?: boolean;
  trigger?: ("click" | "hover" | "contextMenu")[];
  arrow?: boolean;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (visible: boolean) => void;
  overlayClassName?: string;
};

/**
 * @deprecated better use Popover instead
 * @param param0
 * @returns
 */
export const DropdownPopover: FC<PropsWithChildren<DropdownSelectProps>> = ({
  transparent,
  shadow,
  arrow,
  children,
  placement = "bottomLeft",
  content,
  trigger = ["click"],
  disabled,
  defaultOpen,
  open,
  onOpenChange,
  overlayClassName,
}) => {
  const [visible, setVisible] = useState(open ?? defaultOpen ?? false);

  useEffect(() => {
    if (open !== undefined) setVisible(open);
  }, [open]);

  return (
    <Dropdown
      placement={placement}
      trigger={trigger}
      disabled={disabled}
      open={visible}
      arrow={arrow}
      onOpenChange={(x) => {
        setVisible(x);
        onOpenChange?.(x);
      }}
      overlayClassName={cn(
        overlayClassName,
        styles.dropdown_select,
        shadow === true ? "shadow" : undefined,
        transparent === true ? styles.transparent : undefined,
      )}
      overlay={
        <Menu>
          <Menu.Item key="first">{content}</Menu.Item>
        </Menu>
      }
    >
      {children}
    </Dropdown>
  );
};
